import BaseModal from '@c/modals/BaseModal';
import { ArrowRightIcon } from 'lucide-react';
import { Bike } from 'models/shared';
import Link from 'next/link';
import EditGarageForm from './forms/EditGarageForm';
import { UserDocument } from 'models/user';

type EditGarageModalProps = {
  isOpen: boolean;
  dismiss: () => void;
  onAddBikeClick: () => void;
  onSyncSelectedBikes: (bikes: Bike[]) => void;
  previousSelectedBikes: Bike[];
  userDoc: UserDocument;
};

export default function EditGarageModal({
  isOpen,
  dismiss,
  onAddBikeClick,
  onSyncSelectedBikes,
  previousSelectedBikes,
  userDoc,
}: EditGarageModalProps) {
  return (
    <BaseModal isOpen={isOpen} dismiss={dismiss} title="Find Parts That Fit">
      <div className="flex flex-col gap-y-2 pt-8">
        <Link
          href={'/dashboard/my-garage'}
          className="group flex items-center gap-x-2 px-8"
        >
          <span className="text-[1.8rem] font-semibold text-zinc-700 transition-colors duration-150 ease-out group-hover:text-zinc-900">
            My Garage
          </span>

          <ArrowRightIcon className="h-[2rem] w-[2rem] text-zinc-700 transition-colors duration-150 ease-out group-hover:text-zinc-900" />
        </Link>

        <EditGarageForm
          bikes={userDoc.bikes ?? []}
          onAddBikeClick={onAddBikeClick}
          onSyncSelectedBikes={onSyncSelectedBikes}
          previousSelectedBikes={previousSelectedBikes}
        />
      </div>
    </BaseModal>
  );
}
